import { AutocompleteArrayInput, ReferenceArrayInput, required, UPDATE } from 'react-admin'

import { SYSTEM_PERMISSION_LIST, SYSTEM_PERMISSION_READ } from '../config/permissions'
import { useIsFieldPermissionDenied, useResourcePermissions } from '../domain/permissions'

const GroupMembershipInput = ({ source, reference }) => {
  const [canReadGroups, canListGroups] = useResourcePermissions(
    reference,
    SYSTEM_PERMISSION_READ,
    SYSTEM_PERMISSION_LIST,
  )
  const readOnly = useIsFieldPermissionDenied({ action: UPDATE, source })

  if (!canReadGroups || !canListGroups) return null

  return (
    <ReferenceArrayInput source={source} reference={reference} sort={{ field: 'name', order: 'ASC' }}>
      <AutocompleteArrayInput
        optionText="name"
        filterToQuery={(name) => ({ name })}
        validate={required()}
        readOnly={readOnly}
      />
    </ReferenceArrayInput>
  )
}

export default GroupMembershipInput
